(function () {
  "use strict";

  var roots = document.querySelectorAll("[data-gp-site-follow]");
  var deferredPrompt = null;

  if (!roots.length) {
    return;
  }

  function forEachRoot(callback) {
    var index;
    for (index = 0; index < roots.length; index += 1) {
      callback(roots[index]);
    }
  }

  function isStandalone() {
    var standaloneMedia = window.matchMedia && window.matchMedia("(display-mode: standalone)").matches;
    return standaloneMedia || window.navigator.standalone === true;
  }

  function isIOS() {
    var userAgent = window.navigator.userAgent || "";
    var iOSDevice = /iphone|ipad|ipod/i.test(userAgent);
    var iPadDesktopMode = window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1;
    return iOSDevice || iPadDesktopMode;
  }

  function isIOSSafari() {
    var userAgent = window.navigator.userAgent || "";
    var isSafari = /safari/i.test(userAgent) && !/crios|fxios|edgios|opios/i.test(userAgent);
    return isIOS() && isSafari;
  }

  function updateRootVisibility(root) {
    root.hidden = !root.querySelector(".gp-site-follow__channel:not([hidden])");
  }

  function setInstallState(root, state) {
    var channel = root.querySelector("[data-gp-site-follow-install-channel]");
    var button = root.querySelector("[data-gp-site-follow-install]");

    if (!channel || !button) {
      return;
    }

    if (state === "hidden") {
      channel.hidden = true;
      button.hidden = true;
      button.disabled = false;
      button.removeAttribute("aria-busy");
      updateRootVisibility(root);
      return;
    }

    channel.hidden = false;
    button.hidden = false;
    button.disabled = state === "installed";
    button.removeAttribute("aria-busy");

    if (state === "installed") {
      button.textContent = "追加済み";
    } else if (state === "ios") {
      button.textContent = "手順を見る";
    } else {
      button.textContent = "追加";
    }

    updateRootVisibility(root);
  }

  function setAllInstallStates(state) {
    forEachRoot(function (root) {
      setInstallState(root, state);
    });
  }

  function showIOSDialog(root, trigger) {
    var dialog = root.querySelector("[data-gp-site-follow-dialog]");

    if (!dialog) {
      return;
    }

    if (typeof dialog.showModal !== "function") {
      window.alert("Safariの共有メニューから「ホーム画面に追加」を選び、右上の「追加」をタップしてください。");
      return;
    }

    dialog.gpSiteFollowTrigger = trigger;
    if (!dialog.open) {
      dialog.showModal();
    }
  }

  function consumeInstallPrompt(trigger) {
    var promptEvent = deferredPrompt;

    if (!promptEvent) {
      setAllInstallStates("hidden");
      return;
    }

    deferredPrompt = null;
    trigger.disabled = true;
    trigger.setAttribute("aria-busy", "true");

    try {
      promptEvent.prompt();
      promptEvent.userChoice.then(function (choice) {
        if (choice && choice.outcome === "accepted") {
          setAllInstallStates("installed");
        } else {
          setAllInstallStates("hidden");
        }
      }, function () {
        setAllInstallStates("hidden");
      });
    } catch (error) {
      setAllInstallStates("hidden");
    }
  }

  function handleInstallClick(event) {
    var trigger = event.currentTarget;
    var root = trigger.closest("[data-gp-site-follow]");

    if (!root || isStandalone()) {
      return;
    }

    if (isIOSSafari()) {
      showIOSDialog(root, trigger);
      return;
    }

    consumeInstallPrompt(trigger);
  }

  function initializeRoot(root) {
    var installButton = root.querySelector("[data-gp-site-follow-install]");
    var dialog = root.querySelector("[data-gp-site-follow-dialog]");

    if (installButton) {
      installButton.addEventListener("click", handleInstallClick);
    }

    if (dialog) {
      dialog.addEventListener("click", function (event) {
        if (event.target === dialog && dialog.open) {
          dialog.close();
        }
      });

      dialog.addEventListener("close", function () {
        var trigger = dialog.gpSiteFollowTrigger;
        dialog.gpSiteFollowTrigger = null;
        if (trigger && document.contains(trigger)) {
          window.setTimeout(function () {
            trigger.focus();
          }, 0);
        }
      });
    }

    if (isStandalone()) {
      setInstallState(root, "installed");
    } else if (isIOSSafari()) {
      setInstallState(root, "ios");
    }

    updateRootVisibility(root);
  }

  forEachRoot(initializeRoot);

  window.addEventListener("beforeinstallprompt", function (event) {
    event.preventDefault();
    deferredPrompt = event;
    if (!isStandalone()) {
      setAllInstallStates("available");
    }
  });

  window.addEventListener("appinstalled", function () {
    deferredPrompt = null;
    setAllInstallStates("installed");
  });
}());
